export default "__VITE_ASSET__BaI0DD8y__"